import { render, staticRenderFns } from "./goods-qr-code-detail.vue?vue&type=template&id=45c5606d&"
import script from "./goods-qr-code-detail.vue?vue&type=script&lang=js&"
export * from "./goods-qr-code-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports